import * as Constants from './constants'

export const nguoiDungRoleListRequest = function nguoiDungRoleListRequest(formData) {
  return {
    type: Constants.NGUOIDUNG_ROLE_LIST_REQUESTING,
    payload: formData
  }
}

export const nguoiDungRoleListSuccess = function nguoiDungRoleListSuccess(data) {
  return {
    type: Constants.NGUOIDUNG_ROLE_LIST_SUCCESS,
    data
  }
}

export const nguoiDungRoleListError = function nguoiDungRoleListError(error) {
  return {
    type: Constants.NGUOIDUNG_ROLE_LIST_ERROR,
    error
  }
}

export const nguoiDungRoleDetailRequest = function nguoiDungRoleDetailRequest(formData) {
  return {
    type: Constants.NGUOIDUNG_ROLE_DETAIL_REQUESTING,
    payload: formData
  }
}

export const nguoiDungRoleDetailSuccess = function nguoiDungRoleDetailSuccess(data) {
  return {
    type: Constants.NGUOIDUNG_ROLE_DETAIL_SUCCESS,
    data
  }
}

export const nguoiDungRoleDetailError = function nguoiDungRoleDetailError(error) {
  return {
    type: Constants.NGUOIDUNG_ROLE_DETAIL_ERROR,
    error
  }
}

export const nguoiDungRoleUpdateRequest = (formData, callback) => {
  return {
    type: Constants.NGUOIDUNG_ROLE_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const nguoiDungRoleUpdateSuccess = function nguoiDungRoleUpdateSuccess(response) {
  return {
    type: Constants.NGUOIDUNG_ROLE_UPDATE_SUCCESS,
    payload: response
  }
}

export const nguoiDungRoleUpdateError = function nguoiDungRoleUpdateError(error) {
  return {
    type: Constants.NGUOIDUNG_ROLE_UPDATE_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/NguoiDungRole/actions.js